import type { Breakpoint } from '../types/breakpoint';

/**
 * Breakpoint min-widths in px. Mirror of styles/_breakpoints.scss: change both together
 * (breakpoints.test.ts fails if they differ).
 */
export const BREAKPOINTS: Readonly<Record<Exclude<Breakpoint, 'base'>, number>> = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1440,
};

/** Breakpoints from the smallest up, `base` first. */
export const BREAKPOINT_ORDER: readonly Breakpoint[] = ['base', 'sm', 'md', 'lg', 'xl', '2xl'];

/** Class prefix per breakpoint; must match $class-prefixes in styles/_responsive.scss. */
export const BREAKPOINT_CLASS_PREFIX: Readonly<Record<Breakpoint, string>> = {
    base: '',
    sm: 'sm-',
    md: 'md-',
    lg: 'lg-',
    xl: 'xl-',
    '2xl': 'xxl-',
};
